// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"QqzoZF","tooltip":"zIJf1s","tooltipArrow":"vGXSsh"};